import { render, staticRenderFns } from "./ViewItem.vue?vue&type=template&id=123aaaf6&scoped=true&"
import script from "./ViewItem.vue?vue&type=script&lang=js&"
export * from "./ViewItem.vue?vue&type=script&lang=js&"
import style0 from "./ViewItem.vue?vue&type=style&index=0&id=123aaaf6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123aaaf6",
  null
  
)

export default component.exports